import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { usePersonalDetails } from "../../../../../hooks/Profile/hooks/use-personal-details.js";
import { LoadingData } from "../../../../Profile/components/LoadingData.js";
const PersonalGreeting = () => {
  const { personalDetailsData, isFetching } = usePersonalDetails();
  const intl = useIntl();
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(LoadingData, null);
  }
  const showPersonalizedLabel = intl.hasLabel("account.profile.title.personalized") && (personalDetailsData.firstName || personalDetailsData.lastName);
  const message = showPersonalizedLabel ? intl.getFormattedLabel("account.profile.title.personalized", {
    hideLabelKey: true,
    labelData: {
      ...personalDetailsData,
      /**
       * We see a lot of OpCos use the first letter of the first name to
       * create a greeting like "Hello Mr. J. Smith". This data point is usually
       * not in the personal details data we gather via the personal details
       * form, so we create it here on the fly. This allows the OpCo to use
       * this data point in their label.
       */
      ...personalDetailsData.firstName ? { firstLetter: personalDetailsData.firstName.substring(0, 1) } : {}
    }
  }) : intl.getLabel("account.profile.title");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, message);
};
export {
  PersonalGreeting as default
};
//# sourceMappingURL=PersonalGreeting.js.map
